import client, { apiEnv } from '../client';

export const getVehicleCardInformation = (body) => client.post()(
  apiEnv[apiEnv.env].url(
    apiEnv.LAST_PATH.CERTIFICATION,
    apiEnv.APIS.GET_VEHICLE_CARD_INFORMATION,
  ),
  body,
);

export const negotiability = (body) => client.post()(
  apiEnv[apiEnv.env].url(
    apiEnv.LAST_PATH.CERTIFICATION,
    apiEnv.APIS.NEGOTIABILITY,
  ),
  body,
);
